import React, { useEffect } from "react";
import "./WhoWeAre.css";

import img1 from "../../assets/images/Brands1.png";
import img2 from "../../assets/images/Brands2.png";
import img3 from "../../assets/images/Brands3.png";

const WhoWeAre = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".zoom-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="who-section">
      {/* Background Effects */}
      <div className="grid-overlay"></div>
      <div className="particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <span
            key={i}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="who-heading">
        <h2 className="zoom-scroll">Who We Are</h2>
        <div className="scroll-line"></div>
      </div>

      <div className="who-images">
        {[img1, img2, img3].map((img, idx) => (
          <div className="img-card zoom-scroll" key={idx}>
            <img src={img} alt={`Achievement ${idx + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhoWeAre;